// extracted by mini-css-extract-plugin
module.exports = {"label":"RecentSearches_label__2lf16","content":"RecentSearches_content__ImR83"};